import myaxios from "../../components/Axios";


export const getCurrencyService = (name) => {
    return myaxios.get(`/ajax/settings/lookup?type=${name}`)
}